import { ResumeProject } from "lib/redux/types";
import React from "react";
import {
  TemplateNineResumeSection,
  TemplateNineResumeSectionWithSubsections,
} from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import {
  ProjectPDFLink,
  ResumePDFDescription,
  ResumePDFText,
} from "../ResumePDF/common";
import { ResumePDFIcon } from "../ResumePDF/common/ResumePDFIcon";

const Project = ({
  heading,
  projects,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  projects: ResumeProject[];
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateNineResumeSectionWithSubsections
      themeColor={themeColor}
      heading={heading}
    >
      {projects.map(
        ({ project, startDate, endDate, descriptions, projectLink }, idx) => (
          <View key={idx} wrap={false}>
            <View
              style={{
                ...styles.flexRowBetween,
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText bold={true}>{project}</ResumePDFText>
                {projectLink && (
                  <ProjectPDFLink src={projectLink}>
                    <ResumePDFIcon
                      type="url"
                      isPDF={isPDF}
                      themeColor={themeColor}
                    />
                  </ProjectPDFLink>
                )}
              </View>
              <ResumePDFText>
                {startDate && endDate
                  ? `${startDate} - ${endDate}`
                  : startDate || endDate}
              </ResumePDFText>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription
                items={descriptions}
                enableHighlight={enableHighlight}
                enableMistakeHighlight={enableMistakeHighlight}
                section="projects"
                itemIndex={idx}
              />
            </View>
          </View>
        )
      )}
    </TemplateNineResumeSectionWithSubsections>
  );
};

export default Project;
